import React, { useState, useEffect } from "react";
import {
  Button,
  Container,
  Col,
  Form,
  Image,
  Nav,
  Row,
  Tooltip,
  OverlayTrigger, Spinner,
  Modal
} from "react-bootstrap";
import excl_i from "../../../assets/images/icons/excl_i.png";
import trash from "../../../assets/images/icons/trash.svg";
import { useNavigate, NavLink } from "react-router-dom";
import { useUserContext } from "../../../utils/hooks/UserContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { WithContext as ReactTags } from "react-tag-input";
import Select from "react-select";
import {Link} from 'react-router-dom'
import {
  coachAddProgram,
  coachAddSkill,
  coachBenefits,
  coachDeleteProgram,
  coachDeleteSkill,
  coachProfessions,
  coachTags,
  getCategoryList,
} from "../../../utils/api";
import Loader from "../../../Loader/Loader";
import { toast } from "react-toastify";
import { PulseLoader } from "react-spinners";

const EditProfileTags = (props) => {
  const navigate = useNavigate();
    const { getUserFromToken, user } = useUserContext();
    const [tagList, settagList] = useState("");
    const [isSubmitting, setisSubmitting] = useState(false);
  
    useEffect(() => {
      settagList(user?.tags?.toString());
    }, [user]);
  
    const onClickSave = async (values) => {
      try {
        // handle program
        setisSubmitting(true);
        const tagData = new FormData();
        const cleanedTags = tagList
        .split(",")
        .map((item) => item.trim()) // Remove extra spaces
        .filter((item) => item !== "") // Remove empty items
        .map(tag => tag.replace(/['"]/g, ''))
        tagData.append("tags", cleanedTags.join(",")); // Join back to a string
      
        let tagsData = await coachTags(tagData);
        if(tagsData.data?.status){
          toast.success("Tags updated successfully.")
        }else{
          toast.error("Tags not updated successfully.")
        }
        } catch (error) {
        toast.error(error?.response?.data?.message || error?.message);
        setisSubmitting(false);
      }
  
      getUserFromToken();
      setisSubmitting(false);
    };
    const onChangeTagList = (event) => {
      settagList(event?.target?.value);
    };
    
    const tooltipTag = (
      <Tooltip id="tooltip">
        Please input tags, separating each with <strong>commas.</strong>
      </Tooltip>
    );


  return (
    <>
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
      <div className="profile_edit_forms my_light_modal">
        <Form>
          <Container>
            <Row className='g-3'>
              <Col lg="12">
                  <Form.Group className="mb-3" controlId="">
                    <div className="d-flex justify-content-start">
                      <Form.Label className="title me-2 fs-20">Tags</Form.Label>
                      <span>
                        <OverlayTrigger placement="top" overlay={tooltipTag}>
                          <Image src={excl_i} />
                        </OverlayTrigger>
                      </span>
                    </div>
                    <div className="react-tags-message fs-14">
                     
                     <div className="tags_display d-flex flex-wrap mb-2">
                        {tagList
                          .split(",")
                          .map((item) => item.trim()) // Remove extra spaces
                          .filter((item) => item !== "") // Remove empty items
                          .map((item, index) => (
                            <div key={index} className="tags_on_edit me-1">#{item}</div>
                        ))}
                        </div>
                      <Form.Control
                        onChange={onChangeTagList}
                        value={tagList}
                        as="textarea"
                        rows={3}
                        placeholder="Please input your tags, separated by commas."
                      />
                    </div>
                  </Form.Group>
              </Col>
            </Row>
            <Row className='justify-content-end mt-4'>
              <Col sm="auto">
                  <Button variant='success' className='px-5' onClick={onClickSave}>Save</Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </div>
    </Modal>
    </>
  );
}

export default EditProfileTags;